import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const selfServicePlugin = createPlugin({
  id: 'self-service',
  routes: { root: rootRouteRef },
});

/** The self-service catalogue, mounted at /self-service. */
export const SelfServicePage = selfServicePlugin.provide(
  createRoutableExtension({
    name: 'SelfServicePage',
    component: () =>
      import('./components/SelfServicePage').then(m => m.SelfServicePage),
    mountPoint: rootRouteRef,
  }),
);
